export default "__VITE_ASSET__FanwIpE4__"